import { render, staticRenderFns } from "./TheUserDrawer.vue?vue&type=template&id=2abb6109&"
import script from "./TheUserDrawer.vue?vue&type=script&lang=ts&"
export * from "./TheUserDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports